var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logos"},_vm._l((_vm.logos),function(logo){return _c('img',{key:logo.alt,attrs:{"src":logo.src,"alt":logo.alt}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }